import type { ColumnDef } from '@ics-portal/ics-data-table';
import { type GetComponentsPagedQuery } from '@gql/graphql';

export type ComponentRow =
    GetComponentsPagedQuery['components']['edges'][number]['node'];

export const COMPONENT_COLUMNS: ColumnDef<ComponentRow>[] = [
    {
        field: 'id',
        header: 'ID',
        filter: 'text',
        filterKey: 'id',
        sortKey: 'ID',
    },
    {
        field: 'name',
        header: 'Component',
        filter: 'text',
        filterKey: 'name',
        sortKey: 'NAME',
    },
    {
        field: 'version',
        header: 'Version',
        filter: 'text',
        filterKey: 'version',
        sortKey: 'VERSION',
    },
    {
        field: 'eolReached',
        header: 'EOL reached',
        type: 'boolean',
        filterKey: 'eolReached',
        sortKey: 'EOLREACHED',
    },
    {
        field: 'componentVendor.name',
        header: 'Vendor',
        filter: 'text',
        filterKey: 'hasComponentVendorWith.name',
        sortable: false,
    },
    {
        field: 'monitoredSince',
        header: 'Monitored since',
        type: 'shortDate',
        filterKey: 'monitoredSince',
        sortKey: 'MONITOREDSINCE',
    },
    {
        field: 'createTime',
        header: 'Created',
        type: 'shortDate',
        filterKey: 'createTime',
        sortKey: 'CREATETIME',
    },
    {
        field: 'updateTime',
        header: 'Last updated',
        type: 'shortDate',
        filterKey: 'updateTime',
        sortKey: 'UPDATETIME',
    },
    {
        id: 'hasAssessment',
        header: 'Has assessment',
        type: 'boolean',
        value: (row) => Boolean(row.componentVendor.assessments?.find(Boolean)),
        filterKey: 'hasComponentVendorWith.hasAssessments',
        sortable: false,
    },
    {
        field: 'componentVendor.id',
        header: 'Vendor ID',
        hidden: true,
        filter: 'text',
        filterKey: 'componentVendorID',
        sortable: false,
    },
    {
        field: 'componentVendor.ifa',
        header: 'Vendor IFA',
        hidden: true,
        filter: 'text',
        filterKey: 'hasComponentVendorWith.ifa',
        sortable: false,
    },
    {
        field: 'componentVendor.description',
        header: 'Vendor description',
        hidden: true,
        filter: 'text',
        filterKey: 'hasComponentVendorWith.description',
        sortable: false,
    },
    {
        field: 'eolDate',
        header: 'EOL date',
        hidden: true,
        type: 'shortDate',
        filterKey: 'eolDate',
        sortKey: 'EOLDATE',
    },
    {
        field: 'cpeName',
        header: 'CPE name',
        hidden: true,
        filter: 'text',
        filterKey: 'cpeName',
        sortKey: 'CPENAME',
    },
    {
        field: 'url',
        header: 'URL',
        hidden: true,
        filter: 'text',
        filterKey: 'url',
        sortKey: 'URL',
    },
    {
        field: 'securityUrl',
        header: 'Security URL',
        hidden: true,
        filter: 'text',
        filterKey: 'securityURL',
        sortKey: 'SECURITYURL',
    },
    {
        field: 'isValid',
        header: 'Valid',
        hidden: true,
        type: 'boolean',
        filterKey: 'isValid',
        sortKey: 'ISVALID',
    },
];
